import { render } from "./SelectAdmin.vue?vue&type=template&id=39de8605&scoped=true"
import script from "./SelectAdmin.vue?vue&type=script&lang=js"
export * from "./SelectAdmin.vue?vue&type=script&lang=js"

import "./SelectAdmin.vue?vue&type=style&index=0&id=39de8605&scoped=true&lang=less"

import exportComponent from "D:\\Tsubakimoto\\Tsubakimoto_mvc\\Tsubakimoto\\tsubakimoto_fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39de8605"]])

export default __exports__